import { render, staticRenderFns } from "./DebtAccountList.vue?vue&type=template&id=d64cc32e&scoped=true"
import script from "./DebtAccountList.vue?vue&type=script&lang=js"
export * from "./DebtAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64cc32e",
  null
  
)

export default component.exports